import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import PropTypes from 'prop-types';

const InputSwitchPM = ({ onValueChange = null, name = null, className = '', checked = false }) => {
  InputSwitchPM.propTypes = {
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    checked: PropTypes.bool,
    className: PropTypes.string,
  };

  return (
    <div className={`InputSwitch ${className}`}>
      <InputSwitch name={name} checked={checked} onChange={onValueChange} />
    </div>
  );
};

export default InputSwitchPM;